const header = () => {
  const mobileMenu = () => {
    const mobileMenu = document.getElementById('js-mobile-menu')
    const gradient = document.getElementById('js-slide-out-gradient')
    const siteMenu = document.querySelectorAll('.site-menu')[0]
    const siteContact = document.querySelectorAll('.site-contact')[0]
    const siteSearch = document.querySelectorAll('.site-search')[0]
    const btns = document.querySelectorAll('.slide-out-element__toggle')
    let algoliaLoaded = false

    btns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        if (btn.classList.contains('js-search-toggle')) {
          if (algoliaLoaded === false) {
            import('../algolia/algolia.js')
              .then(({ default: initSiteSearch }) => {
                initSiteSearch()
                algoliaLoaded = true
                return
              })
              .then(() => {
                const searchInput =
                  document.querySelectorAll('.ais-SearchBox-input')[0] ?? null
                return searchInput
              })
              .then((searchInput) => {
                searchInput.focus()
              })
              .catch((error) => {
                algoliaLoaded = false
                console.error("Error loading 'Algolia Search' module:", error)
              })
          }

          siteSearch.classList.toggle('is-active')
          siteMenu.classList.remove('is-active')
          siteContact && siteContact.classList.remove('is-active')
        } else if (btn.classList.contains('js-menu-toggle')) {
          siteMenu.classList.toggle('is-active')
          siteSearch.classList.remove('is-active')
          siteContact && siteContact.classList.remove('is-active')
        } else if (btn.classList.contains('js-contact-toggle')) {
          siteContact.classList.toggle('is-active')
          siteSearch.classList.remove('is-active')
          siteMenu.classList.remove('is-active')
        }

        closeMenus('0%')

        siteMenu.classList.contains('is-active') ||
        siteSearch.classList.contains('is-active') ||
        (siteContact && siteContact.classList.contains('is-active'))
          ? gradient.classList.add('js-active')
          : gradient.classList.remove('js-active')
      })
    })

    const closeMenus = (val) => {
      left(val)

      setTimeout(() => {
        mobileMenu
          .querySelectorAll('.js-children-active')
          .forEach((elm) => elm.classList.remove('js-children-active'))
      }, 350)
    }

    mobileMenu.addEventListener('click', (e) => {
      if (e.target instanceof HTMLAnchorElement) return

      e.preventDefault()

      const currentLeft = parseFloat(mobileMenu.style.left)

      if (e.target.classList.contains('js-toggle-children')) {
        e.target.parentElement.classList.add('js-children-active')
        left(`${currentLeft - 100}%`)
      } else if (e.target.classList.contains('js-show-parent')) {
        left(`${currentLeft + 100}%`)

        setTimeout(() => {
          e.target.parentElement.parentElement.previousSibling.classList.remove(
            'js-children-active',
          )
        }, 350)
      }
    })

    const left = (val) => {
      return (mobileMenu.style.left = val)
    }
  }

  const headerChange = () => {
    let scrollpos = window.scrollY

    const header = document.querySelectorAll('.site-header-refresh')[0]
    const headerHeight = header.offsetHeight
    const addClass = () => header.classList.add('site-header--bg')
    const removeClass = () => header.classList.remove('site-header--bg')

    window.addEventListener('scroll', () => {
      scrollpos = window.scrollY
      scrollpos >= headerHeight ? addClass() : removeClass()
    })
  }

  mobileMenu()
  headerChange()
}

export default header
